module.exports = __webpack_public_path__ + "img/Moore_-_NE-t-20543-038.d2cea94c.jpg";